import React from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { bool, func } from 'prop-types';
import useMobileView from '@/hooks/ui/useMobileView';
import translate from '@/lib/intl/translate';

type CredentialsConfirmRemoveModalProps = {
  open: boolean;
  handleClose: () => void;
  handleRemove: () => void;
  setOpen: (open: boolean) => void;
};

export default function CredentialsConfirmRemoveModal({
  open,
  handleClose,
  handleRemove,
  setOpen,
}: CredentialsConfirmRemoveModalProps) {
  const isMobile = useMobileView();
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="mx-auto my-36 w-full max-w-lg rounded-lg bg-white">
        <div className="border-b border-grey-300 p-6 type-body1">
          {translate('INTEGRATIONS_CONFIRM_DESCRIPTION')}
        </div>
        <div className="flex flex-wrap justify-end p-6">
          <Button
            id="credentials-remove-cancel"
            onClick={handleClose}
            variant="text"
            fullWidth={isMobile}
            className="order-2 md:order-none"
          >
            {translate('INTEGRATIONS_CANCEL')}
          </Button>
          <Button
            color="destructive"
            className="order-1 mb-2 md:order-none md:mb-2 md:ml-2"
            id="credentials-remove-confirm"
            onClick={() => {
              handleRemove();
              setOpen(false);
            }}
            variant="contained"
            fullWidth={isMobile}
          >
            {translate('INTEGRATIONS_REMOVE_CONNECTION')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

CredentialsConfirmRemoveModal.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  handleRemove: func.isRequired,
  setOpen: func.isRequired,
};
